import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
export var hexToRgba = function hexToRgba(hex, opacity) {
  if (!hex.includes('#')) {
    console.error('hexToRgba (ui-kit) got not hex format');
    return;
  }
  var r = parseInt(hex.slice(1, 3), 16);
  var g = parseInt(hex.slice(3, 5), 16);
  var b = parseInt(hex.slice(5, 7), 16);
  return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(opacity, ")");
};
//# sourceMappingURL=hexToRgba.js.map